var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_83_948)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8981 6.78479C11.8981 9.54621 9.6595 11.7848 6.89807 11.7848M11.8981 6.78479C11.8981 4.02337 9.6595 1.78479 6.89807 1.78479M11.8981 6.78479L1.89807 6.78479M6.89807 11.7848C4.13665 11.7848 1.89807 9.54621 1.89807 6.78479M6.89807 11.7848C7.81855 11.7848 8.56474 9.54621 8.56474 6.78479C8.56474 4.02337 7.81855 1.78479 6.89807 1.78479M6.89807 11.7848C5.9776 11.7848 5.2314 9.54621 5.2314 6.78479C5.2314 4.02337 5.9776 1.78479 6.89807 1.78479M1.89807 6.78479C1.89807 4.02337 4.13665 1.78479 6.89807 1.78479",
    stroke: "#FDFBF7",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_83_948"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.898071 0.78479)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebLogo);
export default __webpack_public_path__ + "static/media/web_logo.6b2cc938ddc407a66d0016744f50a821.svg";
export { ForwardRef as ReactComponent };